const apiBase = process.env.REACT_APP_ZOOM_API_BASE || '';

async function handleResponse(res) {
  let payload = {};
  try {
    payload = await res.json();
  } catch {
    payload = {};
  }
  if (!res.ok) {
    throw new Error(payload?.error || 'Unable to load courses.');
  }
  return payload;
}

export async function listCourses() {
  const res = await fetch(`${apiBase}/api/courses`);
  return handleResponse(res);
}
